import { TextField } from 'mui-rff';
import React from 'react';

type TBaseProps = Parameters<typeof TextField>[0];
type TProps = TBaseProps;

export default function IntegerField(props: TProps) {
  return <TextField {...props} fieldProps={{ parse: (value) => value && parseInt(value) }} />;
}
